import securityMeta from '@/router/security/securityMeta.js'

export default [
  {
    path: '/security/profile/info/:id',
    name: 'security-profile-info',
    meta: securityMeta,
    component: () => import('@/views/Security/Profile/SecurityProfileInfoView.vue'),
  },
  {
    path: '/security/profile/documents/:id',
    name: 'security-profile-documents',
    meta: securityMeta,
    component: () => import('@/views/Security/Profile/SecurityProfileDocumentsView.vue'),
  },
  {
    path: '/security/profile/changelog/:id',
    name: 'security-profile-changelog',
    meta: securityMeta,
    component: () => import('@/views/Security/Profile/SecurityProfileChangelogView.vue'),
  },
  {
    path: '/security/profile/edit/:id',
    name: 'security-profile-edit',
    meta: securityMeta,
    component: () => import('@/views/Security/Profile/SecurityProfileEditView.vue'),
  },
  {
    path: '/security/profile/history/:id',
    name: 'security-profile-history',
    meta: securityMeta,
    component: () => import('@/views/Security/Profile/SecurityProfileHistoryView.vue'),
  },
]
